import React, { FC } from "react";

import {
  FormControl,
  InputBase,
  InputBaseProps,
  InputLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { ColorPrimary } from "./theme";

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  color: "black",
}));

const StyledTextField = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    border: "1px solid #CBCBCB",
    fontSize: "16px",
    padding: "7.5px 14px !important",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
  },
}));

type IgTextFieldTopLabelProps = {
  label: string;
  fontWeight?: number;
  testPilotBlue?: boolean;
} & InputBaseProps;

/**
 * @see InputBase
 * @see InputLabel
 * @see FormControl
 */
export const IgTextFieldTopLabel: FC<IgTextFieldTopLabelProps> = (props) => {
  const { label, fontWeight, sx, testPilotBlue, ...rest } = props;

  return (
    <FormControl variant="standard" sx={{ width: "100%" }}>
      <StyledInputLabel sx={{ fontWeight: fontWeight || 400, ...sx }} shrink>
        {label}
      </StyledInputLabel>
      <StyledTextField
        {...rest}
        sx={{
          "& .MuiInputBase-input:focus": {
            border: `1px solid`,
            borderColor: testPilotBlue ? "#313C68" : ColorPrimary.main,
          },
        }}
      />
    </FormControl>
  );
};
